import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { TestReportsService } from './api/testReports.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ToySafetyReportsApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ToySafetyReportsApiModule> {
        return {
            ngModule: ToySafetyReportsApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ToySafetyReportsApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ToySafetyReportsApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
